<template>
  <div class="c-carouselbox__container">
    <!-- <img :src="image" alt class="c-carouselbox__image" /> -->
    <img :src="'static/tempAssets/'+image+'.jpg'" alt class="c-carouselbox__image img-fluid" />
    <!-- <h1 class="c-carouselbox__title">{{title}}</h1> -->
    <h1 class="c-carouselbox__title">{{title}}</h1>
    <div class="c-carouselbox__points" v-on:click="scrollToTop()">
      <span class="c-carouselbox__points__text">Gioca</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    image: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    cost: {
      type: Number,
      required: true
    }
  },
  methods: {
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/mixins.scss";

.c-carouselbox__container {
  position: relative;
  width : 100%;
  display: flex;
  flex-direction: column;
  text-align: center;
  box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.2);
  border: solid 1px #979797;
  border-radius: 5px;
  background-color: white;
  height : auto;
  @include md {
    padding: 2rem 1rem;
    margin: 1rem;
  }
  @include lg {
    padding: 2rem 2rem 2rem;
  }
}

.c-carouselbox__image {
  padding: 1rem 1rem;
  border-radius: 8px;
  @include md {
    padding: 0;
  }
}

.c-carouselbox__title {
  padding: 0 2rem 4rem;
  font-size: 18px;
  margin-bottom: 2rem;
  color: #2b2b2b;
  @include md {
    padding: 2rem 1rem 0;
    font-size: 24px;
  }
  @include lg {
    padding-top: 3rem;
  }
}

.c-carouselbox__points {
  cursor: pointer;
  position: absolute;
  bottom: -23px;
  left: calc(50% - 71px);
  border: solid 1px #0058A2;
  font-size: 1.3rem;
  font-weight: 400;
  background: #0058A2;
  color: white;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 142px;
  height: 46px;
  @include md {
    left: calc(50% - 81px);
    width: 162px;
    height: 55px;
  }
}

.c-carouselbox__points__text {
  font-size: 18px;
}
</style>